/* global $ */

// register events for google tag manager
window.dataLayer = window.dataLayer || [];
if (environment == 'development')
{
    $('body').addClass('loaded');
}
import { initLazyLoad, openSalesChannelModal, initVideoListener, showModalLogin, showPopupLogin, callPinterestAPI, showModal3DDownload } from "@api/utils_2020";
import { event } from "jquery";
import { initializedComponents } from './initializedComponents';
window.initializeComponent = [];
window.loadedComponents = [];

const init = () => {
    UtilUi.initializeJSmart();

    const pageID = $("body")
        .attr("id")
        .toLowerCase();

    // initialize components
    for (let funcId in initializedComponents) {
        // console.log(initializedComponents[funcId]);
        // tests if component is present on document
        if (
            document.querySelector("." + initializedComponents[funcId]) !== null &&
            !loadedComponents[initializedComponents[funcId]]
        ) {
            loadedComponents[initializedComponents[funcId]] = true;
            var pbComponent = initializedComponents[funcId];
            console.log(pbComponent);
            //console.log(pbComponent.substring(0,4));
            if (pbComponent.substring(0, 4) == 'pbds') {
                import(/* webpackChunkName: "[request]" */ `../../templates/source/assets/components-pbds/${pbComponent}/${pbComponent}.css`);
                import(/* webpackChunkName: "[request]" */ `../../templates/source/assets/components-pbds/${pbComponent}/${pbComponent}.js`)
                    .then((module) => /* module.default() */ {
                        if (typeof module.default == 'function')
                            module.default()
                    }
                    );
            } else if (pbComponent.substring(0, 4) == 'pb23') {
                import(/* webpackChunkName: "[request]" */ `../../templates/source/assets/components-new/${pbComponent}/${pbComponent}.css`);
                import(/* webpackChunkName: "[request]" */ `../../templates/source/assets/components-new/${pbComponent}/${pbComponent}.js`)
                    .then((module) => /* module.default() */ {
                        if (typeof module.default == 'function')
                            module.default()
                    }
                    );
            }
            else if (pbComponent.substring(0, 4) == 'pbds') {
                import(/* webpackChunkName: "[request]" */ `../../templates/source/assets/components-pbds/${pbComponent}/${pbComponent}.css`);
                import(/* webpackChunkName: "[request]" */ `../../templates/source/assets/components-pbds/${pbComponent}/${pbComponent}.js`)
                    .then((module) => /* module.default() */ {
                        if (typeof module.default == 'function')
                            module.default()
                    }
                    );
            }
            else {
                import(/* webpackChunkName: "[request]" */`../../templates/source/assets/components/${pbComponent}/${pbComponent}.css`);
                import(/* webpackChunkName: "[request]" */ `../../templates/source/assets/components/${pbComponent}/${pbComponent}.js`)
                    .then((module) => /* module.default() */ {
                        if (typeof module.default == 'function')
                            module.default()
                    });
            }

            // initializedComponents[funcId].init();
        }
    }
   

    if (!$('body').hasClass('modalOpened')) {
        switch (pageID) {
            case "index_index":
                import(/* webpackChunkName: "/cover" */ "./pages/cover").then((module) => module.default());
                break;
            case "login_index":
                import(/* webpackChunkName: "/login" */ "./pages/login").then((module) => module.default());
                break;
            case "line_index":
            case "line_search":
            case "line_list":
            case "line_material":
            case "line_indexporcelanato":
                import(/* webpackChunkName: "/lines" */ "./pages/lines").then((module) => module.default());
                break;
            case "line_officinanew":
            case "line_officinalines":
                import(/* webpackChunkName: "/officina" */ "./pages/officina").then((module) => module.default());
                break;
            case "products_index":
            case "products_cersaie":
                import(/* webpackChunkName: "/productsDiscounts" */ "./pages/productsDiscounts").then((module) => module.default());
                break;
            case "products_indexnew":
                import(/* webpackChunkName: "/productsDiscountsNew" */ "./pages/productsDiscountsNew").then((module) => module.default());
                break;
            case "products_index2024":
                import(/* webpackChunkName: "/productsDiscounts2024" */ "./pages/productsDiscounts2024").then((module) => module.default());
                break;
            case "products_indexspecial":
                import(/* webpackChunkName: "/productsDiscountsSpecial" */ "./pages/productsDiscountsSpecial").then((module) => module.default());
                break;
            case "products_indexprice":
                import(/* webpackChunkName: "/productsDiscountsPrice" */ "./pages/productsDiscountsPrice").then((module) => module.default());
                break;
            case "products_complementares":
                import(/* webpackChunkName: "/productsComplementares" */ "./pages/productsComplementares").then((module) => module.default());
                break;
            case "line_view":
            case "line_viewofficina":
                import(/* webpackChunkName: "/line" */ "./pages/line").then((module) => module.default());
                break;
            case "product_groupcolor":
                import(/* webpackChunkName: "/productGroupColor" */ "./pages/productGroupColor").then((module) =>
                    module.default()
                );
                break;
            case "product_downloads":
                import(/* webpackChunkName: "/download" */ "./pages/download.js").then((module) => module.default());
                break;
            case "product_downloadscategory":
                import(/* webpackChunkName: "/downloadCategory" */ "./pages/downloadCategory.js").then((module) => module.default());
                break;
            case "product_downloadssearch":
                import(/* webpackChunkName: "/downloadSearch" */ "./pages/downloadSearch.js").then((module) => module.default());
                break;
            case "specifier_index":
                import(/* webpackChunkName: "/specifier" */ "./pages/specifier.js").then((module) => module.default());
                break;
            case "specifier_experience":
                import(/* webpackChunkName: "/experience" */ "./pages/experience.js").then((module) => module.default());
                break;
            case "contact_index":
                import(/* webpackChunkName: "/contact" */ "./pages/contact.js").then((module) => module.default());
                break;
            case "directsale_signup":
                import(/* webpackChunkName: "/directSale-signup" */ "./pages/directSale-signup.js").then((module) => module.default());
                break;
            case "directsale_edit":
                import(/* webpackChunkName: "/directSale-edit" */ "./pages/directSale-edit.js").then((module) => module.default());
                break;
            case "directsale_index":
                import(/* webpackChunkName: "/directSale" */ "./pages/directSale.js").then((module) => module.default());
                break;
            case "product_index":
            //case "product_lastrasproducts":
                import(/* webpackChunkName: "/products" */ "./pages/products").then((module) => module.default());
                break;
            case "product_lastrasproducts":
                import(/* webpackChunkName: "/lines" */ "./pages/lines").then((module) => module.default());
            break;
            case "product_search":
                import(/* webpackChunkName: "/search" */ "./pages/search.js").then((module) => module.default());
                break;
            case "product_searchsimple":
                import(/* webpackChunkName: "/searchSimple" */ "./pages/searchSimple.js").then((module) => module.default());
                break;
            case "product_searchsimplenew":
                import(/* webpackChunkName: "/searchSimple" */ "./pages/searchSimple.js").then((module) => module.default());
                import(/* webpackChunkName: "/downloadCategory" */ "./pages/downloadCategory.js").then((module) => module.default());
                //import(/* webpackChunkName: "/downloadSearch" */ "./pages/downloadSearch.js").then((module) => module.default());
                break;                
            case "product_view":
            case "product_viewofficina":
                import(/* webpackChunkName: "/product" */ "./pages/product.js").then((module) => module.default());
                import(/* webpackChunkName: "/cart" */ "./pages/cart.js").then((module) => module.default());
                break;
            case "myshoppro_list":
                import(/* webpackChunkName: "/myshop" */ "./pages/myshop--list.js").then((module) => module.default());
                break;
            case "myshoppro_create":
                import(/* webpackChunkName: "/myshop" */ "./pages/myshop--create.js").then((module) => module.default());
                break;
            case "myshoppro_edit":
                // import(/* webpackChunkName: "/myshop" */ "./pages/myshop--edit.js").then((module) => module.default());
                import(/* webpackChunkName: "/myshop" */ "./pages/myshop--edit-v2.js").then((module) => module.default());
                break;
            case "cart_list":
                import(/* webpackChunkName: "/cartList" */ "./pages/cartList.js").then((module) => module.default());
                break;
            case "cart_add":
                import(/* webpackChunkName: "/cartCreate" */ "./pages/cartCreate.js").then((module) => module.default());
                break;
            case "cart_edit":
                import(/* webpackChunkName: "/cartEdit" */ "./pages/cartEdit.js").then((module) => module.default());
                break;
            case "product_wishlist":
                import(/* webpackChunkName: "/productWishlist" */ "./pages/productWishlist.js").then((module) => module.default());
                break;
            case "product_discontinued":
                import(/* webpackChunkName: "/contact" */ "./pages/discontinued.js").then((module) => module.default());
                break;
            case "product_downloadslaudo":
                import(/* webpackChunkName: "/contact" */ "./pages/downloadsDiscontinued.js").then((module) => module.default());
                break;
            case "product_downloadsimages":
                import(/* webpackChunkName: "/contact" */ "./pages/downloads-images.js").then((module) => module.default());
                break;
            case "product_downloads3d":
                import(/* webpackChunkName: "/contact" */ "./pages/downloads3d.js").then((module) => module.default());
                break;
            case "index_terms":
                import(/* webpackChunkName: "/terms" */ "./pages/terms.js").then((module) => module.default());
                break;
            case "index_work":
                import(/* webpackChunkName: "/careers" */ "./pages/careers.js").then((module) => module.default());
                break;
            case "index_sustainability":
            case "index_sustainabilityproduct":
            case "index_sustainabilitypeople":
            case "index_sustainabilitybusiness":
            case "index_sustainabilitywater":
            case "index_sustainabilityzero":
            case "index_sustainabilityfire":
            case "index_sustainabilityearth":
            case "index_sustainabilitysteps":
                import(/* webpackChunkName: "/sustainability" */ "./pages/sustainability.js").then((module) => module.default());
                break;
            case "index_designweek":
                import(/* webpackChunkName: "/designweek" */ "./pages/designweek.js").then((module) => module.default());
                break;

            case "index_innovation":
            case "index_innovationdocs":
            case "index_innovationcoletivo":
            case "index_innovationbastidores":
            case "index_innovationcersaie":
                import(/* webpackChunkName: "/innovation" */ "./pages/innovation.js").then((module) => module.default());
                break;
            case "product_lastras":
                import(/* webpackChunkName: "/lastras" */ "./pages/lastras.js").then((module) => module.default());
                break;
            case "index_about":
                import(/* webpackChunkName: "/about" */ "./pages/about.js").then((module) => module.default());
                break;
            case "index_coletivosolidario":
                import(/* webpackChunkName: "/coletivosolidario" */ "./pages/coletivosolidario.js").then((module) => module.default());
                break;
            case "index_preview2021":
                import(/* webpackChunkName: "/preview2021Ciclo01" */ "./pages/202101-ciclo01.js").then((module) => module.default());
                break;
            case "index_salesforce":
            case "index_salesforcelp":
                import(/* webpackChunkName: "/contatoloja" */ "./pages/contatoloja.js").then((module) => module.default());
                break;
            case "internalconsent_index":
                import(/* webpackChunkName: "/contatoloja" */ "./pages/internalconsent.js").then((module) => module.default());
                break;
            case "index_maisarq":
                import(/* webpackChunkName: "/maisarquitetura-static" */ "./pages/maisarquitetura-static.js").then((module) => module.default());
                break;
            case "index_mostra2021":
                import(/* webpackChunkName: "/mostra2021" */ "./pages/mostra2021.js").then((module) => module.default());
                break;
            case "index_mostra2021projeto":
                import(/* webpackChunkName: "/mostra2021projeto" */ "./pages/mostra2021projeto.js").then((module) => module.default());
                break;
            case "index_casacorevent":
            case "index_casacor":
            case "mostras_casacorevent":
            case "mostras_casacor":
                import(/* webpackChunkName: "/casacor" */ "./pages/casacor.js").then((module) => module.default());
                break;
            case "index_casacorprojeto":
            case "mostras_casacorprojeto":
                import(/* webpackChunkName: "/casacorprojeto" */ "./pages/casacorProjeto.js").then((module) => module.default());
                break;
            case "mostras_index":
            case "mostras_search":
                import(/* webpackChunkName: "/mostras" */ "./pages/mostras.js").then((module) => module.default());
                break;
            case "index_galeria2021":
                import(/* webpackChunkName: "/galeria2021" */ "./pages/galeria2021.js").then((module) => module.default());
                break;
            case "index_galeria2021projeto":
                import(/* webpackChunkName: "/galeria2021projeto" */ "./pages/galeria2021projeto.js").then((module) => module.default());
                break;
            case "index_revestir2021":
                import(/* webpackChunkName: "/revestir2021" */ "./pages/revestir2021.js").then((module) => module.default());
                break;
            case "index_revestir2022":
            case "index_revestir2022subscription":
            case "index_revestir2022videos":
                import(/* webpackChunkName: "/revestir2022" */ "./pages/revestir2022.js").then((module) => module.default());
                break;
            case "index_revestir2023":
                import(/* webpackChunkName: "/revestir2023" */ "./pages/revestir2023.js").then((module) => module.default());
                break;
            case "index_revestir2024":
                import(/* webpackChunkName: "/revestir2024" */ "./pages/revestir2024.js").then((module) => module.default());
                break;
            case "page_archtrendssummit":
                import(/* webpackChunkName: "/archtrendsSummit" */ "./pages/archtrendsSummit.js").then((module) => module.default());
                break;
            case "page_archtrendssummitlive":
                import(/* webpackChunkName: "/archtrendsSummit" */ "./pages/archtrendsSummitLive.js").then((module) => module.default());
                break;
            case "page_dreams2022live":
                import(/* webpackChunkName: "/dreamsLive" */ "./pages/dreamsLive.js").then((module) => module.default());
                break;
            case "page_trendbook23":
                import(/* webpackChunkName: "/archtrendsSummit" */ "./pages/trendbook23.js").then((module) => module.default());
                break;
            case "page_prw23":
                import(/* webpackChunkName: "/archtrendsSummit" */ "./pages/prw23.js").then((module) => module.default());
                break;
            case "page_parceirosofficina":
                import(/* webpackChunkName: "/archtrendsSummit" */ "./pages/parceirosofficina.js").then((module) => module.default());
                break;
            case "page_editorial":
            case "page_editorialed1":
            case "page_editorialed2":
            case "page_editorialed3":
            case "page_editorialed4":
            case "page_editorialed5":
                import(/* webpackChunkName: "/editorial" */ "./pages/editorial.js").then((module) => module.default());
                break;
            case "page_b2b":
                import(/* webpackChunkName: "/b2b" */ "./pages/b2b.js").then((module) => module.default());
                break;
            case "page_franqueadoras":
                import(/* webpackChunkName: "/franqueadoras" */ "./pages/franqueadoras.js").then((module) => module.default());
                break;
            case "page_obrascomerciais":
                import(/* webpackChunkName: "/obrascomerciais" */ "./pages/obrascomerciais.js").then((module) => module.default());
                break;
            case "dreambook_index":
            case "dreambook_ed1":
            case "dreambook_ed2":
            case "dreambook_ed3":
            case "dreambook_ed4":
            case "dreambook_ed5":
                import(/* webpackChunkName: "/dreambox" */ "./pages/dreambook.js").then((module) => module.default());
                break;
            case "page_reportmilao2022":
                import(/* webpackChunkName: "/dreambox" */ "./pages/reportMilao.js").then((module) => module.default());
                break;
            case "page_reportcersaie2022":
                import(/* webpackChunkName: "/dreambox" */ "./pages/reportCersaie.js").then((module) => module.default());
                break;
            case "product_servicosassentamentos":
                import(/* webpackChunkName: "/assentamento" */ "./pages/assentamento.js").then((module) => module.default());
                //import(/* webpackChunkName: "/specifier" */ "./pages/specifier.js").then((module) => module.default());
                break;
            case "page_pagedynamic":
                var pageId = $('body').data('pageid');
                switch (pageId) {
                    case 1:
                        import(/* webpackChunkName: "/maisarquitetura" */ "./pages/maisarquitetura.js").then((module) => module.default());
                        break;
                }
                break;
            case "page_dynpageviewreleases":
                import(/* webpackChunkName: "/lancamentos" */ "./pages/lancamentos.js").then((module) => module.default());
                break;
            case "inside_index":
                import(/* webpackChunkName: "/inside" */ "./pages/inside.js").then((module) => module.default());
                break;
            case "lead_index":
            case "lead_embed":
            case "lead_indexb":
                import(/* webpackChunkName: "/lead" */ "./pages/lead.js").then((module) => module.default());
                break;
            case "product_porcelanateria":
            case "product_porcelanateriaacesso":
                import(/* webpackChunkName: "/porcelanateria" */ "./pages/porcelanateria.js").then((module) => module.default());
                break;
            case "specifier_notifications":
                import(/* webpackChunkName: "/specifierNotification" */ "./pages/specifierNotification.js").then((module) => module.default());
                break;
            case "helpfaq_index":
                import(/* webpackChunkName: "/helpFaq" */ "./pages/helpFaq.js").then((module) => module.default());
                break;
            case "help_index":
                import(/* webpackChunkName: "/helpTracking" */ "./pages/helpTracking.js").then((module) => module.default());
                break;
            case "tracking_index":
            case "tracking_order":
                import(/* webpackChunkName: "/tracking" */ "./pages/tracking.js").then((module) => module.default());
                break;
            case "franchise_index":
            case "franchise_franchiseform01":
            case "franchise_franchiseform02":
            case "franchise_franchiseform04":
            case "franchise_franchiseform05":
                import(/* webpackChunkName: "/franchise" */ "./pages/franchise.js").then((module) => module.default());
                break;
            case "franchise_franchiseformfinal":
                import(/* webpackChunkName: "/franchiseSend" */ "./pages/franchiseSend.js").then((module) => module.default());       
                break;               
            case "dreamcloud_index":
            case "dreamcloud_list":
            case "dreamcloud_show":
            case "dreamcloud_tv":
                import(/* webpackChunkName: "/dreamCloud" */ "./pages/dreamCloud.js").then((module) => module.default());
                break;
            case "modelviewer_index":
                import(/* webpackChunkName: "/modelViewer" */ "./pages/modelViewer.js").then((module) => module.default());
                break;
            case "qrcodeproductgroupcolor_index":
                import(/* webpackChunkName: "/qrcodeproductgroupcolor" */ "./pages/qrcodeproductgroupcolor.js").then((module) => module.default());
                break;
            case "service_etiquetasnew":
            case "service_etiquetasnewprint":
                import(/* webpackChunkName: "/labels" */ "./pages/labels1.js").then((module) => module.default());
                break;                
            case "wheretobuy_indexsimplificated":
                import(/* webpackChunkName: "/wheretobuylist" */ "./pages/wheretobuylist.js").then((module) => module.default());
                break;                
            default:
                break;
        }
    }

    // modal languages
    $(".jsLanguage").off('click').on('click', function (e) {
        e.preventDefault();
        $("#languages-modal-v2").showModal();
        $("body").addClass("showModal");
        return false;
    });
    $(".jsLanguageCover").off('click').on('click', function (e) {
        e.preventDefault();
        UtilUi.loadTemplate("assets/components-pbds/pbds-modal--languages/pbds-modal--languages-language.tpl", (dataOn, tpl) => {
            let html = tpl.fetch({ 
                firstLanguage: lang,
                urlImageServer: urlImageServer,
                urlHome: urlhome,
                url: url
             });
            $("body").append(html);

            $("#languages-modal-v4").showModal();
        });
        $("body").addClass("showModal");
        return false;
    });
    // Fecha languages
    $("body")
        .off("click", "#languages-modal-v2 button.close.jsDialogClose")
        .on("click", "#languages-modal-v2 button.close.jsDialogClose", function (e) {
            e.preventDefault();
            $("#languages-modal-v2").closest('dialog').closeModal();
            $("body").removeClass("showModal");
            return false;
        });
    $("body")
        .off("click", "#languages-modal-v3 button.close.jsDialogClose")
        .on("click", "#languages-modal-v3 button.close.jsDialogClose", function (e) {
            e.preventDefault();
            $("#languages-modal-v3").closest('dialog').closeModal();
            $("body").removeClass("showModal");
            return false;
        });
    $("body")
    .off("click", "#languages-modal-v4 button.close.jsDialogClose")
    .on("click", "#languages-modal-v4 button.close.jsDialogClose", function (e) {
        e.preventDefault();
        $("#languages-modal-v4").closest('dialog').closeModal();
        $("body").removeClass("showModal");
        return false;
    });
    // labels for lastras / lancamentos - link to open page
    $("body")
        .off("click", "label.lastra,label.new")
        .on("click", "label.lastra,label.new", function (e) {
            e.preventDefault();
            var link = $(this).data('link');
            window.open(link, '_blank');
            return false;
        });

    $("body")
        .off("click", "a.noLink")
        .on("click", "a.noLink", function (e) {
            e.preventDefault();
            return false;
        });

    // dialog open / close
    $("body")
        .off("click", "a.link-modal")
        .on("click", "a.link-modal", function (e) {
            e.preventDefault();
            var target = this.hash;
            //$(target)[0].show();
            $(target).showModal();
            return false;
    });
    
    $("body")
        .off("click", ".jsModal")
        .on("click", ".jsModal", function (e) {
            e.preventDefault();
            var target = $(this).data('target');
            //$(target)[0].show();
            $(target).showModal();
            return false;
    });
    

    $("body")
        .off("click", ".jsCloseModal")
        .on("click", ".jsCloseModal", function (e) {
            e.preventDefault();
            var target = $(this).parents('dialog');
            //target[0].close();
            target.closeModal();
            return false;
    });

        

    var favoriteFunction = (selector) => {
        const id = selector.data('id');
        const type = selector.data('type');
        const favorited = selector.attr('favorited');
        const itemElem = selector;
        if (userLogged) {
            $(this).addClass('disabled');
            Util.service("WSPortobelloSite", true, {
                exceptionHandler: console.error,
                reflectSuccess: pbSiteService => {
                    if (favorited) {
                        pbSiteService.removeFromWishlist(id, type, {
                            success: resultDelete => {
                                selector.removeClass('disabled');
                                if (resultDelete) {
                                    selector.removeAttr('favorited');
                                    //$(this).find('img.icon').attr('src', '/template/images/icons/icon_favorite-item.svg');
                                    //alert('Removido do favorito com sucesso!');  
                                } else {
                                    alert('Houve uma falha ao tentar remover dos favoritos, tente novamente!');
                                }
                            }
                        });
                    } else {
                        pbSiteService.addItemWishlist(id, type, {
                            success: resultInsert => {
                                selector.removeClass('disabled');
                                if (resultInsert) {
                                    selector.attr('favorited', true);
                                    //$(this).find('img.icon').attr('src', '/template/images/icons/icon_favorite-item-hover.svg');
                                    //alert('Adicionado ao favorito com sucesso!');  


                                    if (type == 'group') {
                                        // var link = itemElem.parent().find('a.product-group').attr('href');
                                        var title = itemElem.parent().find('span.title').text();
                                        dataLayer.push({
                                            'event': "favorite_item", // Nome do evento.
                                            'group': {
                                                'name': title.replace(/[\n]/g, '').trim(), // Categoria do filtro.
                                            }
                                            // 'url': 'https://www.portobello.com.br' + link // filtro que será aplicado.
                                        });
                                    }
                                    else if (type == 'line') {
                                        var title = itemElem.data('name');
                                        dataLayer.push({
                                            'event': "favorite_item", // Nome do evento.
                                            'line': {
                                                'name': title.replace(/[\n]/g, '').trim(), // Categoria do filtro.
                                            }
                                        });
                                    }
                                    else {
                                        var title = itemElem.data('name') ? itemElem.data('name') : itemElem.parent().find('span.title').text();
                                        dataLayer.push({
                                            'event': "favorite_item", // Nome do evento.
                                            'product': {
                                                'name': title.replace(/[\n]/g, '').trim(), // Categoria do filtro.
                                            }
                                        });
                                    }
                                } else {
                                    alert('Houve uma falha ao tentar adicionar aos favorito, tente novamente!');
                                }
                            }
                        });
                    }
                },
                reflectError: function () {
                    console.error("Erro de conexão, verifique sua conexão com a internet.");
                },
            });
        }
        else {
            const link = window.location.href;
            // não logado
            initVideoListener();
            showModalLogin(link);
            Util.setCookie('wishlistAdd', id + '|' + type);
        }
        return false;
    }

    $(".favorite-cta, .favorite-page-cta").on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        favoriteFunction($(this));
        return;
    })

    $("body")
        .off("click", ".favorite-cta, .favorite-page-cta")
        .on("click", ".favorite-cta, .favorite-page-cta", function (e) {
            alert('click');
            e.preventDefault();
            e.stopPropagation();
            favoriteFunction($(this));
            return;
        });

    if (userLogged) {
        const products = JSON.parse(localStorage.getItem("productsWishlist"));

        if (products && products.length > 0) {
            Util.service("WSPortobelloSite", true, {
                exceptionHandler: console.error,
                reflectSuccess: function (pbSiteService) {
                    products.forEach((product, index) => {
                        pbSiteService.addItemWishlist(product.id, 'product', {
                            success: resultInsert => {
                                if (index + 1 == products.length)
                                    localStorage.clear();
                            }
                        });
                    })
                },
                reflectError: function () {
                    console.error("Erro de conexão, verifique sua conexão com a internet.");
                },
            });
        }

        var toAdd = Util.getCookie('wishlistAdd');
        if (toAdd) {
            var toAddVar = toAdd.split('|');
            var id = toAddVar[0];
            var type = toAddVar[1];

            Util.service("WSPortobelloSite", true, {
                exceptionHandler: console.error,
                reflectSuccess: function (pbSiteService) {
                    pbSiteService.addItemWishlist(id, type, {
                        success: resultInsert => {
                            if (resultInsert) {
                                Util.deleteCookie('wishlistAdd');
                                $('.favorite-cta[data-id="' + id + '"][data-type="' + type + '"],.favorite-page-cta[data-id="' + id + '"][data-type="' + type + '"]').attr('favorited', true);
                            }
                            else {
                                alert('Houve uma falha ao tentar adicionar aos favorito, tente novamente!');
                            }
                        }

                    });
                },
                reflectError: function () {
                    console.error("Erro de conexão, verifique sua conexão com a internet.");
                },
            });


        }
    }

    if (lang != 'pt_BR' && lang != 'pt_br' && lang != 'pt' && salesChannel == '') {
        switch ($('body').data('controller')) {
            case 'Page':
            case 'Index':
                break;
            default:
                // openSalesChannelModal();
                break;
        }

    }

    $(document).on("ready", function () {
        let zipInterval;
        Util.service("WSPortobelloSite", true, {
            exceptionHandler: console.error,
            reflectSuccess: function (pbSiteService) {
                pbSiteService.getMyZipList({
                    success: items => {
                        if (items) {
                            UtilUi.loadTemplate("assets/components/pb-list--zip/pb-list--zip.tpl", (dataOn, tpl) => {
                                let zipItems = Object.values(items);
                                let html = tpl.fetch({ zipItems });
                                $("body").append(html);

                                zipInterval = setInterval(() => {
                                    pbSiteService.getMyZipList({
                                        success: refreshItems => {
                                            if (refreshItems) {
                                                UtilUi.loadTemplate("assets/components/pb-list--zip/pb-zip--items.tpl", (dataOn, tpl) => {
                                                    zipItems = Object.values(refreshItems);
                                                    html = tpl.fetch({ zipItems });
                                                    $("#selected-list .items").html(html);
                                                });
                                            } else {
                                                $("#selected-list").remove();
                                                clearInterval(zipInterval);
                                            }
                                        }
                                    })
                                }, 10000);
                            });
                        }
                    }
                });
            },
            reflectError: function () {
                console.error("Erro de conexão, verifique sua conexão com a internet.");
            },
        });

        $('body').off('click', '#jsRemoveZipItem').on('click', '#jsRemoveZipItem', function (e) {
            e.preventDefault();
            const idImageDamQueue = $(this).data('id');

            Util.service("WSPortobelloSite", true, {
                reflectSuccess: pbSiteService => {
                    pbSiteService.removeZipFromList(idImageDamQueue, {
                        success: result => {
                            if (result) {
                                pbSiteService.getMyZipList({
                                    success: refreshItems => {
                                        if (refreshItems) {
                                            UtilUi.loadTemplate("assets/components/pb-list--zip/pb-zip--items.tpl", (dataOn, tpl) => {
                                                let zipItems = Object.values(refreshItems);
                                                let html = tpl.fetch({ zipItems });
                                                $("#selected-list .items").html(html);
                                            });
                                        } else {
                                            $("#selected-list").remove();
                                            clearInterval(zipInterval);
                                        }
                                    }
                                })
                            }
                        }
                    })
                }
            });

            return false;
        });

        $('body').off('click', '#jsClearZipList').on('click', '#jsClearZipList', function (e) {
            e.preventDefault();

            Util.service("WSPortobelloSite", true, {
                reflectSuccess: pbSiteService => {
                    pbSiteService.clearMyZipList({
                        success: result => {
                            if (result) {
                                $("#selected-list").remove();
                                clearInterval(zipInterval);
                            }
                        }
                    })
                }
            });

            return false;
        });


        $("body").off('click', '#jsToggleZipList').on("click", "#jsToggleZipList", function toggleCart(evt) {
            evt.preventDefault();

            const cart = $("#selected-list");

            if (!cart.hasClass("closed")) {
                cart.addClass("closed");
            } else {
                cart.removeClass("closed");
            }
        });
    });
    initLazyLoad();
    showPopupLogin();
    addGclid();
    addCodigoIndoleads();

    pintrk('track', 'pagevisit', {
        event_id: eventID,
    });
    callPinterestAPI('page_visit');

    var modalParam = getParam("modal");
    var originalUrl = window.location.href;

    $('.jsVideo').on('click', function (event, isTrigger) {
        var videoID = ($(this).data('videoid'))
        var channelParam = getParam("channel");
        if (channelParam == null) {
            var params = '?modal=video&id=' + videoID;
        } else {
            var params = '&modal=video&id=' + videoID;
        }
        if (isTrigger != 'yes') {
            history.pushState(null, null, originalUrl + params);
        }
    })

    setTimeout(() => {
        switch (modalParam) {
            case "a.pb-item":
                setTimeout(() => {
                    const urlParams = new URLSearchParams(window.location.search);
                    const href = urlParams.get('href');
                    $(modalParam + '[href="' + '#' + href + '"').trigger('click');
                }, 1000);
                break;
            case ".jsGrid":
                var title = getParam('title');
                $(modalParam + '[data-title="' + title + '"').trigger('click');
                break;
            case "links":
                $("button[data-toggle='modal']").trigger('click');
                break;
            case "linksv3":
                $("#links").trigger('click');
                break;
            case "video":
                var videoID = getParam("id");
                $('.jsVideo[data-videoid="' + videoID + '"]').trigger('click', 'yes');
                break;
            case "internacional":
                $('.trigger-internacional').trigger('click', 'yes');
                break;
            default:
                $(modalParam).trigger('click');
                break;
        }
    }, 1000);

    // validate channel on url
    // https://portobello.kanbanize.com/ctrl_board/103/cards/23640/details/
    var channelParam = getParam("channel");
    var url = window.location.href;
    function changeUrl(url) {
        console.log(url);
        window.history.pushState({}, "", url);
    }
    if (!channelParam && channelSite) {
        console.log('no-channel');
        console.log(url);
        if (url.search('channel=') >= 0) {
            // tem
            var regex = /channel=[^?&]+/;
            url = url.replace(regex, 'channel=' + channelSite);
        }
        else {
            // não tem
            if (url.search(/\?/) >= 0) {
                url += '&channel=' + channelSite;
            }
            else if (url.search(/\#/) >= 0) {
                var parts = url.split('#');
                url = parts[0]+'?channel=' + channelSite + '#'+parts[1];
            }
            else {
                url += '?channel=' + channelSite;
            }
        }
        changeUrl(url);
    } else if (typeof channelParam == 'undefined' && channelSite) {
        console.log('channel undefined');
        url = url.replace('channel=', '');

        // não tem
        if (url.search(/\?/) >= 0) {
            url += '&channel=' + channelSite;
        }
        else if (url.search(/\#/) >= 0) {
            var parts = url.split('#');
            url = parts[0]+'?channel=' + channelSite + '#'+parts[1];
        }
        else {
            url += '?channel=' + channelSite;
        }
        changeUrl(url);
    } else if ((typeof channelParam == 'undefined' || channelParam == '') && !channelSite) {
        console.log('channel undefined');
        url = url.replace('?channel=', '');
        url = url.replace('&channel=', '');
        changeUrl(url);
    } else if (channelParam != channelSite) {
        console.log('channel diff');
        console.log(channelParam);
        var regex = /channel=[^?&]+/;
        url = url.replace(regex, 'channel=' + channelSite);
        changeUrl(url);
    } else if (channelParam && channelSite) {
        console.log('channel');
        console.log(channelParam);
    }
    if (environment == 'production' || environment == 'staging')
    {
        setTimeout(function () {
            $('body').addClass('loaded');
        }, 300);
    }
    console.log(url);
};

$(function () {
    init();
});

export function closeFilters() {
    $(".filter-container").removeClass("show");
    $("body").removeClass("noScroll");

    return false;
}

window.closeModal = function (source, remove) {
    if ($(source).hasClass("modal-container")) {
        $(source).fadeOut(function () {
            $(this).removeClass("show");
            var keep = $(this).data("keep");
            if (remove && !keep) $(this).remove();
        });
    } else {
        $(source)
            .parents(".modal-full")
            .first()
            .fadeOut(function () {
                $(this).removeClass("show");
                var keep = $(this).data("keep");
                if (remove && !keep) $(this).remove();
            });
        $(source)
            .parents(".modal-container")
            .first()
            .fadeOut(function () {
                $(this).removeClass("show");
                var keep = $(this).data("keep");
                if (remove && !keep) $(this).remove();
            });
    }
    $("body").removeClass("noScroll");
}

window.openModal = function (target) {
    var target = target;

    $(target).addClass("show");
    $(target).css("display", "block");
    $("body").addClass("noScroll");
    return false;
}


// script captura de Ads Google: https://portobelloamerica-team.monday.com/boards/1110640814/pulses/3065880540

function getParam(p) {
    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getExpiryRecord(value) {
    var expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 dias de validade em milissegundos

    var expiryDate = new Date().getTime() + expiryPeriod;
    return {
        value: value,
        expiryDate: expiryDate
    };
}

function addGclid() {
    var gclidParam = getParam('gclid');
    var gclidFormFields = ['gclid']; // todos os IDs de campo de formulário gclid possíveis aqui
    var gclidRecord = null;
    var currGclidFormField;

    var gclsrcParam = getParam('gclsrc');
    var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

    gclidFormFields.forEach(function (field) {
        if (document.getElementById(field)) {
            currGclidFormField = document.getElementById(field);
        }
    });

    if (gclidParam && isGclsrcValid) {
        gclidRecord = getExpiryRecord(gclidParam);
        localStorage.setItem('gclid', JSON.stringify(gclidRecord));
    }

    var gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
    var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;

    if (currGclidFormField && isGclidValid) {
        currGclidFormField.value = gclid.value;
    }
}


function addCodigoIndoleads() {
    var codigo_indoleadsParam = getParam('codigo_indoleads');
    var codigo_indoleadsFormFields = ['codigo_indoleads']; // todos os IDs de campo de formulário codigo_indoleads possíveis aqui
    var codigo_indoleadsRecord = null;
    var currCodigoIndoleadsFormField;

    var gclsrcParam = getParam('gclsrc');
    var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

    codigo_indoleadsFormFields.forEach(function (field) {
        if (document.getElementById(field)) {
            currCodigoIndoleadsFormField = document.getElementById(field);
        }
    });

    if (codigo_indoleadsParam && isGclsrcValid) {
        codigo_indoleadsRecord = getExpiryRecord(codigo_indoleadsParam);
        localStorage.setItem('codigo_indoleads', JSON.stringify(codigo_indoleadsRecord));
    }

    var codigo_indoleads = codigo_indoleadsRecord || JSON.parse(localStorage.getItem('codigo_indoleads'));
    var isCodigoIndoleadsValid = codigo_indoleads && new Date().getTime() < codigo_indoleads.expiryDate;

    if (currCodigoIndoleadsFormField && isCodigoIndoleadsValid) {
        currCodigoIndoleadsFormField.value = codigo_indoleads.value;
    }
}


function in_array(needle, haystack, argStrict) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: vlado houba
    // +   input by: Billy
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // *     example 1: in_array('van', ['Kevin', 'van', 'Zonneveld']);
    // *     returns 1: true
    // *     example 2: in_array('vlado', {0: 'Kevin', vlado: 'van', 1: 'Zonneveld'});
    // *     returns 2: false
    // *     example 3: in_array(1, ['1', '2', '3']);
    // *     returns 3: true
    // *     example 3: in_array(1, ['1', '2', '3'], false);
    // *     returns 3: true
    // *     example 4: in_array(1, ['1', '2', '3'], true);
    // *     returns 4: false
    var key = "",
        strict = !!argStrict;

        console.log('needle');
        console.log(needle);
        console.log('haystack');
        console.log(haystack);

    if (strict) {
        for (key in haystack) {
            if (haystack[key] === needle) {
                return true;
            }
        }
    } else {
        for (key in haystack) {
            if (haystack[key] == needle) {
                return true;
            }
        }
    }

    return false;
}

window.showConsentPreferencesPopup = function()
{
    $('#adopt-controller-button').trigger('click');
    setTimeout( function()
    {
        $('#adopt-preferences-button').trigger('click');
    },500);
    return false;
}